import {Component, OnInit} from '@angular/core';
import {LaboratoriosService} from "./laboratorios.service";
import {LaboratoriosModel} from "./laboratorios.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "app/login/login.service";

declare var swal: any;

@Component({
  selector: 'app-laboratorios',
  templateUrl: './laboratorios.component.html'
})
export class LaboratoriosComponent extends Components implements OnInit {

  laboratorios: LaboratoriosModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private laboratoriosService: LaboratoriosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        const p = data.privilegios[i];
        const acaoUrl = (p.acao && p.acao[0] && p.acao[0].url) ? p.acao[0].url : '';
        const idAcao = String(p.id_acao || '');

        if(idAcao === '20' || acaoUrl == 'laboratorios' || acaoUrl == 'prestacao-mapa' || acaoUrl == 'mercado-interno'){
          this.privilegioUsuario.consultar = p.consultar;
          this.privilegioUsuario.editar = p.editar;
        }
      }
      if(this.func.userIsMaster()){
        this.privilegioUsuario.consultar = true;
        this.privilegioUsuario.editar = true;
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.laboratoriosService.getPaginacao(1,this.itensPorPagina)
      .subscribe(data => {
        this.laboratorios = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.laboratorios);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });


  }

  delete(laboratorio) {
    let laboratorios = this.laboratorios;
    let laboratoriosService = this.laboratoriosService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarLaboratorio')+laboratorio.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(laboratorios);
        }

        let index = laboratorios.indexOf(laboratorio);
        laboratorios.splice(index, 1);

        laboratoriosService.apagar(laboratorio.id_laboratorio)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.laboratorios = laboratorios;
            },
            err => {
              // Revert the view back to its original state
              laboratorios.splice(index, 0, laboratorio);
              self.laboratorios = laboratorios;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.laboratoriosService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.laboratorios = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/laboratorios/laboratorios.component.ts